let subscribers = [];
let listening = false;

const onScrollHandler = () => {
  subscribers.forEach(fn => fn());
};

export const add = listener => {
  subscribers = subscribers.concat(listener);

  if (!listening) {
    listening = true;
    window.addEventListener("scroll", onScrollHandler);
    window.addEventListener("resize", onScrollHandler);
  }
};
export const remove = listener => {
  subscribers = subscribers.filter(fn => fn !== listener);

  if (listening && subscribers.length === 0) {
    listening = false;
    window.removeEventListener("scroll", onScrollHandler);
    window.removeEventListener("resize", onScrollHandler);
  }
};